<script lang="ts" setup>
    import { GlobeAltIcon, ChevronDownIcon } from '@heroicons/vue/24/outline';
    import Button from '@/shared/ui/Button/Button.vue';
    import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuRadioGroup, DropdownMenuRadioItem } from '@/shared/ui/DropdownMenu';
    import languageService from '@/services/language.service';

    const { locale } = useI18n();
    const selectedLAnguage = computed(() => languageService.languages.find((l) => l.code === locale.value));

    watch(locale, (value) => languageService.setLocaleLanguage(value));
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <Button variant="tertiary">
                <template #iconLetf><GlobeAltIcon class="hidden sm:block" /></template>
                <span>{{ selectedLAnguage?.label }}</span>
                <template #iconRight><ChevronDownIcon /></template>
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
            <DropdownMenuRadioGroup v-model="locale">
                <DropdownMenuRadioItem
                    v-for="lang in languageService.languages"
                    :key="lang.code"
                    :value="lang.code"
                >
                    {{ lang.full }}
                </DropdownMenuRadioItem>
            </DropdownMenuRadioGroup>
        </DropdownMenuContent>
    </DropdownMenu>
</template>
